import React, { Component } from 'react';
import { GenericError } from '@fluid/callouts';
import PropTypes from 'prop-types';

const DEFAULT_ERROR_TITLE = 'Error';
const DEFAULT_ERROR_MSG = 'There was an error loading the widget';

export default class WidgetErrorBoundary extends Component {
    static propTypes = {
        messages: PropTypes.object.isRequired,
    };

    static getDerivedStateFromError(e) {
        console.log('Error rendering widget', e);

        return { hasError: true };
    }

    state = {
        hasError: false,
    };

    render() {
        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            const { messages } = this.props;
            const { widget = {} } = messages || {};
            const errorMessages = {};

            if (widget) {
                const { loadErrorTitle, loadErrorMessage } = widget;
                errorMessages.title = loadErrorTitle || DEFAULT_ERROR_TITLE;
                errorMessages.msg = loadErrorMessage || DEFAULT_ERROR_MSG;
            }

            return <GenericError {...errorMessages} />;
        }

        return children;
    }
}
